var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "BattleDialog" } },
    [
      _vm.visible
        ? _c(
            "el-dialog",
            {
              staticClass: "sQDialog",
              attrs: {
                top: "30vh",
                visible: _vm.visible,
                show: _vm.visible,
                "show-close": false,
                "close-on-press-escape": false,
                "close-on-click-modal": _vm.closeOnClickModal,
                "append-to-body": ""
              },
              on: {
                "update:visible": function($event) {
                  _vm.visible = $event
                }
              }
            },
            [
              _c(
                "div",
                { staticClass: "alertBox" },
                [
                  _c("div", { staticClass: "tipTitle" }, [
                    _vm._v("\n        " + _vm._s(_vm.tipTitle) + "\n      ")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "content",
                      class: _vm.tipTitle ? "content1" : ""
                    },
                    [_vm._v("\n        " + _vm._s(_vm.content) + "\n      ")]
                  ),
                  _vm._v(" "),
                  _vm._t("contentMy"),
                  _vm._v(" "),
                  _c("div", { staticClass: "btnBox" }, [
                    _c(
                      "div",
                      {
                        staticClass: "confirm cursor",
                        on: { click: _vm.yesBtn }
                      },
                      [_vm._v(_vm._s(_vm.okTxt))]
                    )
                  ])
                ],
                2
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-0c0857ac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-0c0857ac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugin/SQDialog/src/main.vue
// module id = null
// module chunks = 